import { createRuntimeServiceAccessKey } from '../../../../../services/runtimeServices';
import { createLastKnownNetworkRegistry } from '../createLastKnownNetworkRegistry';

export const getLastKnownNetworkRegistry = createRuntimeServiceAccessKey(
  'last-known-network-registry',
  (client) => createLastKnownNetworkRegistry(client)
);
